// TODO: REMOVE THIS ONE
(function () {
    'use strict';

    angular.module('Services').factory('SocketService', SocketService);
    SocketService.$inject = [
        'socketFactory',
        '$http'
    ];
    
    function SocketService(
        socketFactory,
        $http
    ){
        return socketFactory({
            ioSocket: io.connect(socketUrl) 
        });
    }
})();



// WEBPACK FOOTER //
// ./js/services/realtime-data/SocketService.js